import { all, AllEffect, ForkEffect } from "redux-saga/effects";
import infraSaga from "#/infra/saga/index";
import dashboardSaga from "#/modules/dashboard/saga/index";
import applicationsSaga from "../../modules/applications/saga";
import policiesSaga from "../../modules/policies/saga";

export default function* rootSaga(): Generator<AllEffect<Generator<ForkEffect<never>, void, unknown>>, void, unknown> {
  try {
    yield all([
      infraSaga(),
      dashboardSaga(),
      applicationsSaga(),
      policiesSaga(),
    ]);
  } catch (error) {
    console.log("Saga Error!", error);
  }
}
